import { useContext } from 'react';
import { UseMutateFunction } from 'react-query';

import { ReservationLocalstorageSteps } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';
import {
  constructPayloadForAPI,
  localStorageValuesFromFirstStep,
  transformedDiscountsForTable,
} from 'modules/accommodations/features/reservations/helper';
import { useTransitionInStepsTransformedTableData } from 'modules/accommodations/features/reservations/hooks';
import { TApiData, TDiscountTableData } from 'modules/accommodations/features/reservations/models';
import { ReservationNewContext } from 'modules/accommodations/features/reservations/routes/ReservationNewContext';

export const useDiscountSidebarModalHelper = (
  upsertServicesMutate: UseMutateFunction<any, unknown, TApiData, unknown>,
) => {
  const { thirdStepTableState, setThirdStepTableState } = useContext(ReservationNewContext);
  const { servicesTableData, discountsTableData, isDiscountSideBarOpen, rowIndex } =
    thirdStepTableState;

  const localstorageFirstStep = JSON.parse(
    localStorage.getItem(ReservationLocalstorageSteps.FIRSTSTEP) as string,
  );
  const { from, to, numberOfGuestsSum, unitId } =
    localStorageValuesFromFirstStep(localstorageFirstStep);

  const { transformedServicesDataForAPI, transformedDiscountsDataForAPI } =
    useTransitionInStepsTransformedTableData(
      servicesTableData,
      discountsTableData,
      from,
      to,
      numberOfGuestsSum,
      isDiscountSideBarOpen,
    );

  const addDiscount = (values: any) => {
    //data for API
    const discountFormValues = {
      serviceId: 2,
      reservationDiscountType: values.reservationDiscountType,
      dateFrom: from,
      dateTo: to,
      numberOfGuests: numberOfGuestsSum,
      amountPerDiscountType: values.amountPerDiscountType,
      applyDiscountPriceTo: values.applyDiscountPriceTo,
    };

    const mergeNewDiscounts = transformedDiscountsDataForAPI.concat([discountFormValues]);
    const apiPayload: TApiData = constructPayloadForAPI(
      unitId,
      transformedServicesDataForAPI,
      mergeNewDiscounts,
    );

    upsertServicesMutate(apiPayload);

    //data for table discount state
    const transformedDiscount = transformedDiscountsForTable(values, servicesTableData);

    const mergeTransformedDiscount = discountsTableData.concat([transformedDiscount]);
    setThirdStepTableState({
      discountsTableData: mergeTransformedDiscount,
      isDiscountSideBarOpen: false,
    });

    // save new services and discounts to localStorage
    const { calculationServices, calculationDiscountServices } = apiPayload;
    const localStorageData = {
      services: servicesTableData,
      discountServices: mergeTransformedDiscount,
      servicesStepFour: calculationServices,
      discountServicesStepFour: calculationDiscountServices,
    };
    localStorage.setItem(ReservationLocalstorageSteps.THIRDSTEP, JSON.stringify(localStorageData));
  };

  const editDiscount = (values: any) => {
    //edited data for API
    const mergeEditedDiscounts = [...transformedDiscountsDataForAPI];
    mergeEditedDiscounts[rowIndex as number] = values;

    const apiEditedPayload: TApiData = constructPayloadForAPI(
      unitId,
      transformedServicesDataForAPI,
      mergeEditedDiscounts,
    );
    upsertServicesMutate(apiEditedPayload);

    //edited data for table discounts state
    const transformedEditedDiscount: TDiscountTableData = transformedDiscountsForTable(
      values,
      servicesTableData,
    );
    const mergeEditedTransformedDiscounts = [...discountsTableData];
    mergeEditedTransformedDiscounts[rowIndex as number] = transformedEditedDiscount;

    setThirdStepTableState({
      discountsTableData: mergeEditedTransformedDiscounts,
      isDiscountSideBarOpen: false,
    });

    //save edited services and discounts to localStorage
    const { calculationServices, calculationDiscountServices } = apiEditedPayload;
    const localStorageData = {
      services: servicesTableData,
      discountServices: mergeEditedTransformedDiscounts,
      servicesStepFour: calculationServices,
      discountServicesStepFour: calculationDiscountServices,
    };
    localStorage.setItem(ReservationLocalstorageSteps.THIRDSTEP, JSON.stringify(localStorageData));
  };

  return { addDiscount, editDiscount };
};
